import { DefaultRootState } from 'react-redux';

import { Settings, SETTINGS_CONFIG, SettingsConfig, SettingsType } from 'utils/constants/dynamicSettings';
import Debug from 'utils/debug';

type GetSettings = (
    state: DefaultRootState
) => (key: Settings) => string | number | boolean | null | string[] | Record<string, unknown>;

type GetSettingsValue = (
    key: Settings,
    settings: Partial<SettingsConfig>
) => string | number | boolean | null | string[] | Record<string, unknown>;

interface Converter {
    [SettingsType.Number]: (settings: string) => number;
    [SettingsType.String]: (settings: string) => string;
    [SettingsType.Boolean]: (settings: string) => boolean;
    [SettingsType.Array]: (settings: string) => string[];
    [SettingsType.Object]: (settings: string) => Record<string, unknown>;
}

const CONVERTER: Converter = {
    [SettingsType.Number]: (settings) => Number(settings),
    [SettingsType.String]: (settings) => settings,
    [SettingsType.Boolean]: (settings) => settings === 'true',
    [SettingsType.Array]: (settings) => settings.split(','),
    [SettingsType.Object]: (settings) => JSON.parse(settings) as Record<string, unknown>,
};

const VALUE_IF_NULL = {
    [SettingsType.Number]: 0,
    [SettingsType.String]: '',
    [SettingsType.Boolean]: false,
    [SettingsType.Array]: [],
    [SettingsType.Object]: {},
};

export const getSettingsValue: GetSettingsValue = (key, settings) => {
    if (key in SETTINGS_CONFIG && key in settings && settings[key] !== null && settings[key] !== undefined) {
        return CONVERTER[SETTINGS_CONFIG[key]](settings[key] as string);
    }
    if (settings[key] === undefined) {
        return VALUE_IF_NULL[SETTINGS_CONFIG[key]];
    }
    Debug.log('error out', 'Settings error', {
        settingsInConfig: key in SETTINGS_CONFIG,
        settingsName: key,
        settingsValue: settings[key],
    });
    return null;
};

export const getSettings: GetSettings = (state) => {
    const settings = state.dynamicSettings;

    return (key) => getSettingsValue(key, settings);
};
